<ifr-page-title pageTitle="'LEFT_PANEL_EVACUATION_LIST' | translate "/>
<evacuation-list-container
  will-leave="ctrl.willLeave"
  on-will-leave-result="onWillLeaveResult"
/>
